import react from "react";
import images from "../../constant/images";
import { Nav } from "../../layouts/navbar/nav";
import "./apropos.css";
import { Mission } from "./components/mission";
import { Temoignages } from "./components/temoignages";
import Partenairs from "./components/gallery";
// import Footer from "../../layouts/footer/footer";
import { useTranslation } from "react-i18next";
import Header from "../../layouts/header";

export const Apropos = () => {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };
  return (
    <div className="flex flex-col mb-20">
      <Header image={images.about} title={t("aboutUs_content.about")} />

      {/* Mission Section */}
      <div id="Mission">
        <Mission />
      </div>

      {/* Testimonials Section */}
      <div>
        <Temoignages />
      </div>

      {/* Partners Section */}
      {/* <div>
        <Partenairs />
      </div> */}
    </div>
  );
};
